<h1 mat-dialog-title>Change Customer</h1>

<mat-dialog-content>
  <div
    class="flex flex-col justify-start items-stretch max-w-[400px] space-y-4"
  >
    @if (!selectedCustomer) {
      <p>
        Search for the customer who you want to assign this
        {{ data.docketType }} to:
      </p>
      <mat-form-field>
        <input
          matInput
          [formControl]="searchControl"
          name="Customer select"
          [matAutocomplete]="auto"
          name="Search"
          placeholder="Search for a customer"
          type="search"
        />
        <mat-autocomplete
          (optionSelected)="optionSelectedEvent($event)"
          name=""
          [displayWith]="displayFn"
          #auto="matAutocomplete"
        >
          @for (option of filteredCustomers$ | async; track option.id) {
            <mat-option
              [value]="option"
              class="flex flex-col justify-start items-stretch"
            >
              <p>{{ option | customerName }}</p>
              <p>
                <small>{{ option.address_1 }}</small>
              </p>
            </mat-option>
          }
          <mat-option [value]="CREATE_NEW_CUSTOMER">
            <p><em>Create new customer</em></p>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <p>
        You are about to assign this {{ data.docketType }} to
        <strong>{{ selectedCustomer | customerName }}</strong
        >.
      </p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="null">Cancel</button>

  <button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="selectedCustomer"
    [disabled]="!selectedCustomer"
  >
    @if (!selectedCustomer) {
      Assign to selected customer
    } @else {
      Assign to {{ selectedCustomer | customerName }}
    }
  </button>
</mat-dialog-actions>
